export const validatePesel = (pesel) => {
  const reg = /^[0-9]{11}$/
  if (reg.test(pesel) == false) return false
  else {
    const digits = ('' + pesel).split('')
    if (
      parseInt(pesel.substring(4, 6)) > 31 ||
      parseInt(pesel.substring(2, 4)) > 12
    )
      return false

    let checksum =
      (1 * parseInt(digits[0]) +
        3 * parseInt(digits[1]) +
        7 * parseInt(digits[2]) +
        9 * parseInt(digits[3]) +
        1 * parseInt(digits[4]) +
        3 * parseInt(digits[5]) +
        7 * parseInt(digits[6]) +
        9 * parseInt(digits[7]) +
        1 * parseInt(digits[8]) +
        3 * parseInt(digits[9])) %
      10
    if (checksum == 0) checksum = 10
    checksum = 10 - checksum

    return parseInt(digits[10]) == checksum
  }
}

export const validateNip = (nip) => {
  const nipWithoutDashes = nip.replace(/-/g, '')
  const reg = /^[0-9]{10}$/
  if (reg.test(nipWithoutDashes) == false) {
    return false
  } else {
    const digits = ('' + nipWithoutDashes).split('')
    const checksum =
      (6 * parseInt(digits[0]) +
        5 * parseInt(digits[1]) +
        7 * parseInt(digits[2]) +
        2 * parseInt(digits[3]) +
        3 * parseInt(digits[4]) +
        4 * parseInt(digits[5]) +
        5 * parseInt(digits[6]) +
        6 * parseInt(digits[7]) +
        7 * parseInt(digits[8])) %
      11

    return parseInt(digits[9]) == checksum
  }
}

export const validateRegon = (regon) => {
  const reg = /^[0-9]{9}$/
  if (!reg.test(regon)) return false
  else {
    const digits = ('' + regon).split('')
    let checksum =
      (8 * parseInt(digits[0]) +
        9 * parseInt(digits[1]) +
        2 * parseInt(digits[2]) +
        3 * parseInt(digits[3]) +
        4 * parseInt(digits[4]) +
        5 * parseInt(digits[5]) +
        6 * parseInt(digits[6]) +
        7 * parseInt(digits[7])) %
      11
    if (checksum == 10) checksum = 0

    return parseInt(digits[8]) == checksum
  }
}

export const validateEmail = (email) => {
  const regex =
    /^(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[A-Za-z0-9-]*[A-Za-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/
  return regex.test(email)
}

export const validateIPAddress = (ipAddress) => {
  const regex =
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i
  return regex.test(ipAddress)
}

export const validateKrs = (krs) => {
  const regex = /^[0-9]{10}$/
  return regex.test(krs)
}
